import React, { useEffect, useState } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import Marker from './MyMarker';
import Polyline from './MyPolyline';
import './MyMap.scss';

const MapHandler = ({ events }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) {
      return;
    }
    if (events.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      events.forEach((event) => {
        bounds.extend(new window.google.maps.LatLng(event.lat, event.lng));
      });
      map.fitBounds(bounds);
    }
    if (events.length === 1) {
      map.setZoom(14);
    }
  }, [events, map]);

  return null;
};

const MyMap = ({ day, activeElement, onElementChange }) => {
  const { events } = day;
  const [active, setActive] = useState(activeElement);

  const isActive = (type, id) => {
    return active?.type === type && active?.id === id;
  };

  useEffect(() => {
    setActive(activeElement);
  }, [activeElement]);

  return (
    <div className="my-map-wrapper">
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
        <Map
          mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
          defaultZoom={12}
          defaultCenter={{ lat: 49.2591878968048, lng: -123.11323799429735 }}
        >
          {events.map((event, i) => (
            <React.Fragment key={`event-fragment-${event.id}`}>
              <Marker
                key={`event${event.id}`}
                event={event}
                color={day.color}
                text={i + 1}
                active={isActive('event', event.id)}
                onToggle={() =>
                  onElementChange({ type: 'event', id: event.id })
                }
                onCloseClick={() =>
                  onElementChange({ type: 'event', id: event.id })
                }
              />
              {event.route && (
                <Polyline
                  key={`polyline${event.id}`}
                  route={event.route}
                  color={day.color}
                  active={isActive('polyline', events[i - 1]?.id)}
                  onToggle={() =>
                    onElementChange({ type: 'polyline', id: events[i - 1]?.id })
                  }
                />
              )}
            </React.Fragment>
          ))}
        </Map>
        <MapHandler events={events} />
      </APIProvider>
    </div>
  );
};

export default MyMap;
